module.exports = __webpack_public_path__ + "static/media/FacebookOnboard1.38fcc2ac.png";